import React, { FC, useEffect, useState } from 'react';

import { RCXAdapter } from 'rcx_adapter';
import {
    useSecondIFrameState,
    useSecondIFrameDispatch,
    SecondIframeState,
    IFRAME_TOGGLE_WIDTH,
    RCX_IFRAME_WIDTH,
    SECOND_IFRAME_WIDTH,
    SecondIframeAdapter,
} from 'rcx_crm_ui';

import { ServiceNowAdapter } from './adapter';
import { RCXContainer } from './containers/RCXContainer';

const App: FC = () => {
    const [snAdapter, setSNAdapter] = useState<ServiceNowAdapter>();
    const [secondIframeAdapter, setSecondIframeAdapter] = useState<SecondIframeAdapter>();
    const { secondIframe } = useSecondIFrameState();
    const secondIframeDispatch = useSecondIFrameDispatch();
    const secondIframeState = secondIframe.state;

    const initServiceNow = () => {
        const snAdapter = window.rcServiceNowAdapter;
        const rcxAdapter = RCXAdapter.instance();
        const secondIframeAdapter = new SecondIframeAdapter(rcxAdapter, { openCTIApp: snAdapter.showOpenFrame });
        secondIframeAdapter.start(secondIframeDispatch);

        setSNAdapter(snAdapter);
        setSecondIframeAdapter(secondIframeAdapter);
    };
    useEffect(() => {
        if (secondIframeState === SecondIframeState.Collapse) {
            snAdapter?.setFrameWidth(RCX_IFRAME_WIDTH + IFRAME_TOGGLE_WIDTH);
        } else if (secondIframeState === SecondIframeState.Expand) {
            snAdapter?.setFrameWidth(RCX_IFRAME_WIDTH + IFRAME_TOGGLE_WIDTH + SECOND_IFRAME_WIDTH);
        } else {
            snAdapter?.setFrameWidth(RCX_IFRAME_WIDTH);
        }
    }, [secondIframeState, snAdapter]);

    useEffect(() => {
        initServiceNow();
    }, []);

    return <RCXContainer snAdapter={window.rcServiceNowAdapter} secondIframeAdapter={secondIframeAdapter} />;
};

export default App;
